export interface ClergyBioPersonalInfoFormModel {
	firstName: string;
	lastName: string;
	middleName: string;
	placeOfBirth: string;
	nameAppear: string;
	religiousOrder: string;
	personalWebsite: string;
	country: string;
	address1: string;
	address2: string;
	city: string;
	state: string;
    postalCode: string;
    clergyInfoConfirmed: boolean
}

export const religiousOrder = [
    {
        text: 'Anamchara Fellowship', value: 'ACF',
    },
    {
        text: 'Anglican Order of Preachers', value: 'AOP',
    },
    {
        text: 'Brotherhood of Saint Gregory', value: 'BSG',
    },
    {
        text: 'Brothers of Saint John the Evangelist', value: ' OSBBSJE',
    },
    {
        text: 'Conference of Anglican Religious', value: 'CAROA',
    },
    {
        text: 'Community of Celebration', value: 'CC',
    },
    {
        text: 'Congregation of the Companions of the Holy Saviour', value: 'CCHS',
    },
    {
        text: 'Community of the Gospel', value: 'CG',
    },
    {
        text: 'Community of the Holy Spirit', value: 'CHS',
    },
    {
        text: 'Community of Saint John the Baptist', value: 'CSJB',
    },
    {
        text: 'Companions of Saint Luke - Benedictine', value: 'CSL',
    },
    {
        text: 'Community of Saint Mary', value: 'CSM',
    },
    {
        text: 'Community of Saint Mary, Eastern Province', value: 'CSME',
    },
    {
        text: 'Community of Saint Mary, Southern Province', value: 'CSMS',
    },
    {
        text: 'Community of the Transfiguration', value: 'CT',
    },
    {
        text: 'Little Sisters of St. Clare', value: 'FCLSSC',
    },
    {
        text: 'National Association of Episcopal Christian Communities', value: 'NAECC',
    },
    {
        text: 'Order of the Holy Cross (Benedictine)', value: 'OHC',
    },
    {
        text: 'Order of Julian of Norwich', value: 'OJN',
    },
    {
        text: 'Order of Saint Anne', value: 'OSA',
    },
    {
        text: 'Order of Saint Benedict', value: 'OSB',
    },
    {
        text: 'Order of Saint Helena', value: 'OSH',
    },
    {
        text: 'Order of the Teachers of the Children of God', value: 'OTCG',
    },
    {
        text: 'Rivendell Community', value: 'RC',
    },
    {
        text: "St. Gregory's Abbey (Benedictine)", value: 'SGA',
    },
    {
        text: 'Sisterhood of the Holy Nativity', value: 'SHN',
    },
    {
        text: 'Sisters of St. Anne - Bethany', value: 'SSAB',
    },
    {
        text: 'Sisters of St. Anne - Chicago', value: 'SSAC',
    },
    {
        text: 'Society of Saint Anna the Prophet', value: 'SSAP',
    },
    {
        text: 'Society of St. Francis', value: 'SSF',
    },
    {
        text: 'Sisters of Saint Gregory', value: 'SSG',
    },
    {
        text: 'Society of Saint John the Evangelist', value: 'SSJE',
    },
    {
        text: 'Society of Saint Margaret', value: 'SSM',
    },
    {
        text: 'Society of Saint Paul', value: 'SSP',
    },
    {
        text: 'Third Order Society of St. Francis, Province of the Americas', value: 'TSSF',
    },
    {
        text: 'Worker Brothers of the Holy Spirit', value: 'WBHS',
    },
    {
        text: 'Worker Sisters of the Holy Spirit', value: 'WSHS',
    },
];